module.exports = __webpack_public_path__ + "img/marquer.82deceb4.png";